import { useEffect, useState } from "react";
import api from "@/lib/api";
import { money } from "@/lib/format";
import { useI18n } from "@/context/I18nContext";
import { usePeriod } from "@/context/PeriodContext";
import {
  TrendingUp, TrendingDown, Wallet, Receipt, FileWarning, Coins,
} from "lucide-react";

function Tile({ label, value, icon: Icon, accent, negative, testid }) {
  const tone = accent ? "text-primary" : negative ? "text-destructive" : "";
  return (
    <div className="rounded-xl border bg-background p-4 shadow-elev-1" data-testid={testid}>
      <div className="flex items-center justify-between mb-2 text-muted-foreground">
        <span className="text-[10px] uppercase tracking-[0.14em] font-semibold">{label}</span>
        {Icon && <div className="w-7 h-7 rounded-lg bg-muted/60 flex items-center justify-center"><Icon className="w-3.5 h-3.5" /></div>}
      </div>
      <div className={`font-mono text-lg md:text-xl font-semibold tracking-[-0.02em] ${tone}`}>{value}</div>
    </div>
  );
}

export default function MonthSummary() {
  const { lang } = useI18n();
  const { periodKey } = usePeriod();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!periodKey) return;
    (async () => {
      try {
        const { data } = await api.get(`/dashboard/workspace?period=${periodKey}`);
        setData(data);
      } catch { /* ignore */ }
    })();
  }, [periodKey]);

  const t = (tr, de) => (lang === "de" ? de : tr);
  const m = data?.month || {};

  return (
    <div className="space-y-2" data-testid="month-summary">
      <div className="flex items-center gap-2">
        <div className="text-[10px] uppercase tracking-[0.14em] font-semibold text-muted-foreground">
          {t("Ay Özeti", "Monatsübersicht")}
        </div>
        <span className="text-xs font-mono text-muted-foreground">{m.period_key || periodKey}</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        <Tile label={t("Ciro", "Umsatz")}     value={money(m.revenue || 0)}      icon={TrendingUp}  testid="ms-revenue" />
        <Tile label={t("Gider", "Ausgaben")}  value={money(m.expenses || 0)}     icon={TrendingDown} testid="ms-expenses" />
        <Tile label={t("Kâr", "Gewinn")}      value={money(m.profit || 0)}       icon={Wallet}       accent testid="ms-profit" />
        <Tile label={t("Net KDV", "Netto-USt.")} value={money(m.net_vat || 0)}   icon={Receipt}      testid="ms-vat" />
        <Tile label={t("Açık Tedarikçi Borcu", "Offene Verb.")} value={money(m.open_payables || 0)} icon={FileWarning} negative={(m.open_payables || 0) > 0} testid="ms-payables" />
        <Tile label={t("Nakit Mevcudu", "Kassenbestand")} value={money(m.cash_balance || 0)} icon={Coins} testid="ms-cash" />
      </div>
    </div>
  );
}
